<div class='row'>
  <div [ngClass]='{ "col-md-6": canDownload(), "col-12": !canDownload() }'>
    <ng-container *ngIf='showAlert'>
      <app-alert
                 [type]='alertType()'
                 [closable]='closableAlert()'
                 alertTittle='Status płatności:'
                 (onClose)='showAlert = false'>
        {{ paymentInfo().status | paymentStatus }}<span class='dot-spinner'
                                                       *ngIf='!["completed", "failed", "cancelled", "expired"].includes(paymentInfo().status || "") && !!paymentInfo()'></span>
      </app-alert>
    </ng-container>
  </div>
  <ng-container *ngIf='canDownload()'>
    <div class='col-md-6 d-flex align-items-center'
         *ngIf='paymentInfo().id as id'>
      <a *ngIf='paymentInfo().status === "completed"' href='#' class='btn btn-secondary'
         style='margin-bottom: 1.5rem'
         (click)='download($event, id)'>
        <i class='fa fa-file-download'></i>
        Pobierz potwierdzenie
      </a>
    </div>
  </ng-container>
</div>
